<template>
  <div v-if="isLoaded">
    <div class="v2-brand-detail">
      <!-- Two-panel layout -->
      <div class="v2-brand-detail__content">
        <div class="v2-brand-detail__sidebar">
          <v2-brand-preview-card
            :brand-details="brandDetails"
            :brand-logo="brandLogo"
            :has-social-links="hasSocialLinks"
            :months-with-collection="monthsWithCollection"
            :is-subscribed="isSubscribed"
            :scheduled-collection-types="scheduledCollectionTypes"
            :format-currency="formatCurrency"
            :text-truncate="textTruncate"
            :on-handle-subscription="onHandleSubscription"
          />
        </div>
        <div class="v2-brand-detail__main">
          <v2-brand-collections
            :live-collections="liveCollections"
            :previous-collections="previousCollections"
            :collections-loaded="collectionsLoaded"
            :fetch-collections="fetchCollectionsForBrand"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="v2-page-loading"
  >
    <v2-spinner
      size="lg"
      label="Loading..."
    />
  </div>
</template>

<script>
import V2Spinner from '@/components/v2/V2Spinner.vue'
import { useBrandDetail } from '@/composables/useBrandDetail'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import UserRoleMixin from '../../apps/UserRoleMixin.vue'
import V2BrandPreviewCard from './V2BrandPreviewCard.vue'
import V2BrandCollections from './V2BrandCollections.vue'

export default {
  name: 'V2BrandDetail',
  components: {
    V2Spinner,
    V2BrandPreviewCard,
    V2BrandCollections,
  },
  mixins: [UserRoleMixin],
  setup() {
    const composable = useBrandDetail()
    return {
      ...composable,
    }
  },
  data() {
    return {
      brandId: this.$route.params.brandId,
    }
  },
  watch: {
    '$route.params.brandId': {
      handler(brandId) {
        if (brandId !== this.brandId) {
          this.brandId = brandId
          this.loadBrand()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.loadBrand()
  },
  methods: {
    loadBrand() {
      this.fetchBrandDetails(this.brandId)
        .then(brand => {
          if (brand) {
            if (this.isRetailer) {
              analytics.track(constants.TRACKS.PAGES.RETAILER_OPENS_BRANDS_PROFILE, {
                entityName: brand.entityName,
                id: brand._id,
              })
            }
          }
        })
      this.fetchCollections(this.brandId)
      if (!this.isGuest) {
        this.getSubscription(this.brandId)
      }
    },
    fetchCollectionsForBrand() {
      this.fetchCollections(this.brandId)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-brand-detail {
  &__content {
    display: flex;
    align-items: stretch;
    height: calc(100vh - var(--v2-space-6) * 2);
    overflow: hidden;
  }

  &__sidebar {
    width: 23%;
    flex-shrink: 0;
    height: 100%;
    overflow-y: auto;
    border-right: 1px solid var(--v2-border);
  }

  &__main {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    padding: var(--v2-space-4) var(--v2-space-6);
  }

}

@media screen and (max-width: 768px) {
  .v2-brand-detail {
    &__content {
      flex-direction: column;
      height: auto;
      overflow: visible;
    }

    &__sidebar {
      width: 100%;
      height: auto;
      overflow-y: visible;
    }

    &__main {
      width: 100%;
      padding: var(--v2-space-4);
    }
  }
}
</style>
